export { JobDescriptionDetailPage } from './JobDescriptionDetailPage';
